const designWidth = 1440;
const baseSize = 16;
function setRem() {
  const scale = document.documentElement.clientWidth / designWidth;
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
  console.log( baseSize * Math.min(scale, 2) + 'px')
}
setRem();
window.onresize = function () {
  setRem();
};
document.addEventListener('visibilitychange', setRem);
window.addEventListener('orientationchange', setRem);
document.documentElement.addEventListener('touchstart', function (event) {
  if (event.touches.length > 1) {
    event.preventDefault();
  }
}, { passive: false });
document.documentElement.addEventListener('touchmove', function (event) {
  if (event.touches.length > 1) {
    event.preventDefault();
  }
}, { passive: false }); 